import {ChevronIcon, Grid, Typography} from '@yandex-delivery/blocks'
import clsx from 'clsx'
import type {ReactElement} from 'react'

import {classes} from './ToggleTitle.classes'
import type {Props} from './ToggleTitle.types'

export function ToggleTitle({title, onClick, isOpened = false}: Props): ReactElement {
  return (
    <Grid alignItems="center" className={classes.root} onClick={onClick} container>
      <Grid item>
        <Typography className={classes.title} data-e2e="toggle-title-title" group="normal" variant="caption1">
          {title}
        </Typography>
      </Grid>
      <Grid item>
        <ChevronIcon className={clsx(classes.icon, {[classes.opened]: isOpened})} data-e2e="toggle-title-chevron" />
      </Grid>
    </Grid>
  )
}
